export const environment = {
  production: true,
  hmr: false,
  appInsights: {
    // instrumentationKey: 'c90fcdda-5a2f-4697-ae46-9cf3aed46bba',
    instrumentationKey: '9fcfa941-0dbe-4fd2-a085-b2850f733604',
  },
};
